import React from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {DynamicTable} from '../../../../components/DynamicTable'
import useGetQuantityIncomingDetails from '../../hooks/useGetQuantityIncomingDetails'

export interface QuantityIncomingDetailsModalProps {
  show: boolean
  onClose: () => void
  variantSku?: string
  dialogClassName?: string
  isParent?: boolean
  title: string
}

const QuantityIncomingDetailsModal: React.FC<QuantityIncomingDetailsModalProps> = ({
  show,
  onClose,
  variantSku = '',
  dialogClassName = 'modal-xl',
  isParent = false,
  title,
}) => {
  const {quantityIncomingDetails, isLoading, onSortingChange} =
    useGetQuantityIncomingDetails(variantSku)

  // Define table columns for quantity incoming details
  const quantityIncomingTableColumns = [
    ...(isParent
      ? [
          {
            key: 'flavours',
            label: 'Flavours',
            headerStyle: 'min-w-120px',
            isSorted: false,
          },
          {
            key: 'sku',
            label: 'SKU',
            headerStyle: 'min-w-120px',
            isSorted: true,
          },
        ]
      : []),
    {
      key: 'po_number',
      label: 'PO NUMBER',
      headerStyle: 'min-w-120px',
      isSorted: false,
    },
    {
      key: 'quantity',
      label: 'Requested QTY',
      headerStyle: 'min-w-175px',
      isSorted: true,
    },
    {
      key: 'received_quantity',
      label: 'Received QTY',
      headerStyle: 'min-w-150px',
      isSorted: true,
    },
    {
      key: 'incoming_qty',
      label: 'INCOMING QTY',
      headerStyle: 'min-w-150px',
      isSorted: true,
    },
  ]

  // Prepare data for DynamicTable
  const tableData = Array.isArray(quantityIncomingDetails)
    ? quantityIncomingDetails
    : quantityIncomingDetails
    ? [quantityIncomingDetails]
    : []

  return (
    <ConfirmationModal
      show={show}
      onClose={onClose}
      dialogClassName={dialogClassName}
      bodyClass='mh-550px overflow-auto'
      disableFooter={false}
      disableAction={true}
      title={<div className='d-flex align-items-center'>{title}</div>}
      body={
        <DynamicTable
          data={tableData}
          sortableColumns={quantityIncomingTableColumns}
          loading={isLoading}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          noDataMessage='No quantity incoming data available for this SKU.'
          onSortingChange={onSortingChange}
          TableRow={({row}: any) => {
            return (
              <tr>
                {isParent && (
                  <>
                    <td>
                      <span className='text-gray-800 fs-6'>{row?.flavor_name || '-'}</span>
                    </td>
                    <td>
                      <span className='text-gray-800 fs-6'>{row?.sku || '-'}</span>
                    </td>
                  </>
                )}
                <td>
                  <span className='text-gray-800 fs-6'>
                    {row?.po_number !== null ? row.po_number : '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 fs-6'>
                    {row?.quantity !== null ? row?.quantity : '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 fs-6'>
                    {row?.received_quantity !== null ? row?.received_quantity : '-'}
                  </span>
                </td>
                <td>
                  <span className='text-gray-800 fs-6'>
                    {row?.incoming_qty !== null ? row?.incoming_qty : '-'}
                  </span>
                </td>
              </tr>
            )
          }}
        />
      }
    />
  )
}

export default QuantityIncomingDetailsModal
